/** @format */
import { createReducer, on } from '@ngrx/store';
import {
	removeAttributeFromErrorList,
	selectedAttributeAction,
	setAllAttributeOptions,
	setAllSelectedAttributeOptions,
	setErrorAttribute
} from './attributes.actions';
import { AttributesState } from '@pdp/data-access/interfaces';

export const initialAttributeState: AttributesState = {
	allAttributeOptions: [],
	selectedAttributeOptions: [],
	errorList: null
};

export const attributesReducers = createReducer(
	initialAttributeState,
	on(selectedAttributeAction, (state, { attributeSelected }) => ({
		...state,
		selectedAttribute: attributeSelected
	})),
	on(setAllAttributeOptions, (state, { attributeOptions }) => ({
		...state,
		allAttributeOptions: attributeOptions
	})),
	on(setAllSelectedAttributeOptions, (state, { allSelectedAttributeOptions }) => ({
		...state,
		selectedAttributeOptions: allSelectedAttributeOptions
	})),
	on(setErrorAttribute, (state, { error }) => ({
		...state,
		errorList: error
	})),
	on(removeAttributeFromErrorList, (state, { attributeGroupName }) => {
		if (!state.errorList || !(attributeGroupName in state.errorList)) {
			return state;
		}
		let newErrorList = { ...state.errorList };
		delete newErrorList[attributeGroupName];
		if (Object.keys(newErrorList).length === 0) {
			newErrorList = null;
		}
		return {
			...state,
			errorList: newErrorList
		};
	})
);

export const attributesReducer = (state, action) => {
	return attributesReducers(state, action);
};
